module.exports = __webpack_public_path__ + "img/clfeature.a9f95761.png";